<div class="topbar-bot">
  <div class="gov">
    <img class="gov-ozadje" src="assets/images/gov.png" alt="" aria-hidden="true" />
    <a [routerLink]="'/'">
      <img src="assets/images/evtLogo.png" alt="Logotip eVloge" />
      <lib-postavitev-info></lib-postavitev-info>
    </a>
  </div>
  <img class="psenica" src="assets/images/psenica.png" alt="" />
</div>
